import React, { useEffect, useState } from 'react';
import genStyles from '../generale.module.css';
import CollectionService from '../../service/CollectionService';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { apiCollectionState, collectionsCurState, loadingState, toastState, userDataState } from '../../atoms/CollectionState';
import ResultForm from '../resultat/resultatForm';


export default function SharedCollectionForm({ onClose, collectionName, mode = 'edit' }) {
    const collectioncur = useRecoilValue(collectionsCurState);
    const api_collection = useRecoilValue(apiCollectionState);
    const user_data = useRecoilValue(userDataState);       
    const setToast = useSetRecoilState(toastState);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortConfig, setSortConfig] = useState(null);
    const [userlist, setUserlist] = useState([]);
    const setLoading = useSetRecoilState(loadingState);

    const api = api_collection + user_data.account.port + '/';
    const userAccountId = user_data.account.id;
    const userId = user_data.user.id;
    const iddCollectionSelected = collectioncur.id;
    const idcollectionProprio = collectioncur.sogefi_operateur_creation;

    useEffect(() => {
        CollectionService.getUsersAccount(api, userAccountId).then((response) => {
            const resptemp = response.map(user => {
                let accessLect = false;
                let accessEdit = false;
                let accessAdd = false;
                let accessDelete = false;
    
                // Si c'est le propriétaire, tout est true
                if (user.id_utilisateur === idcollectionProprio) {
                    accessLect = true;
                    accessEdit = true;
                    accessAdd = true;
                    accessDelete = true;
                } else {
                    const collection_share = JSON.parse(user.collection_share);
                    if (collection_share.share) {
                        collection_share.share.forEach(c => {
                            if (c.info.collection_id === iddCollectionSelected) {
                                accessLect = c.info.read;
                                accessEdit = c.info.edit;
                                accessAdd = c.info.add;
                                accessDelete = c.info.delete;
                            }
                        });
                    }
                }
                let displayName;

                if (user.id_utilisateur === userId) {
                    // Cas : c'est l'utilisateur connecté
                    if (user.id_utilisateur === idcollectionProprio) {
                        // c'est aussi le proprio → couronne + "Moi"
                        displayName = (
                            <span>
                                <i className={`fa-solid fa-crown yellow-text text-darken-3 ${genStyles.icomargin}`}></i>
                                <b>Moi</b>
                            </span>
                        );
                    } else {
                        // c'est l'utilisateur connecté mais pas le proprio → juste "Moi"
                        displayName = <b>Moi</b>;
                    }
                } else if (user.id_utilisateur === idcollectionProprio) {
                    // Cas : c'est le proprio (et ce n'est PAS l'utilisateur connecté)
                    displayName = (
                        <span>
                            <i className={`fa-solid fa-crown yellow-text text-darken-3 ${genStyles.icomargin}`}></i>
                            <b>{user.nom_utilisateur}</b>
                        </span>
                    );
                } else {
                    // Sinon, nom normal
                    displayName = user.nom_utilisateur;
                }

                return {
                    id: user.id_utilisateur,
                    nom: displayName,
                    email: user.email_utilisateur,
                    lecture: accessLect,
                    edition: accessEdit,
                    ajout: accessAdd,
                    suppression: accessDelete,
                    isProprio: user.id_utilisateur === idcollectionProprio // nouveau flag
                };
            });
            const uniqueResptemp = [
                ...new Map(resptemp.map(item => [item.id, item])).values()
            ];
            // ----- Séparer en deux groupes -----
            const groupe1 = uniqueResptemp
                .filter(u =>
                    u.isProprio || u.lecture || u.edition || u.ajout || u.suppression
                )
                .sort((a, b) => b.isProprio - a.isProprio); // proprio en premier

            const groupe2 = uniqueResptemp.filter(u => !groupe1.includes(u));

            // ----- Construire le tableau final -----
            const finalList = [
                { id:'groupe-1', isFullRow: true, fullText: 'Utilisateur ayant des droits sur cette collection' },
                ...groupe1.map(u => ({ ...u, groupId: 'groupe-1' })),
                { id:'groupe-2', isFullRow: true, fullText: 'Autres utilisateurs ayant accés au module' },
                ...groupe2.map(u => ({ ...u, groupId: 'groupe-2' }))
            ];
            setUserlist(finalList);
            setLoading(false);
        });
    }, []);
    
    const handleCheckboxChange = (id, key, value) => {
        setLoading(true);  
        const rowcur = userlist.find((user) => !user.isFullRow && user.id === id);
        if (!rowcur) return;

        let lecture = rowcur.lecture;
        let edition = rowcur.edition;
        let ajout = rowcur.ajout;
        let suppression = rowcur.suppression;

        if (value) {
            // Cas "cocher"
            switch (key) {
                case 'lecture':
                    lecture = true;
                    break;
                case 'edition':
                    lecture = true;
                    edition = true;
                    break;
                case 'ajout':
                    lecture = true;
                    edition = true;
                    ajout = true;
                    break;
                case 'suppression':
                    lecture = true;
                    edition = true;
                    ajout = true;
                    suppression = true;
                    break;
            }
        } else {
            // Cas "décocher"
            switch (key) {
                case 'lecture':
                    lecture = false;
                    edition = false;
                    ajout = false;
                    suppression = false;
                    break;
                case 'edition':
                    edition = false;
                    ajout = false;
                    suppression = false;
                    break;
                case 'ajout':
                    ajout = false;
                    suppression = false;
                    break;
                case 'suppression':
                    suppression = false;
                    break;
            }
        }       
        // On reconstruit la ligne mise à jour
        const rowUpdated = { ...rowcur, lecture, edition, ajout, suppression };
        const data = {
            account_id: userAccountId,
            add:rowUpdated.ajout,
            collection_id:iddCollectionSelected,
            delete:rowUpdated.suppression,
            edit:rowUpdated.edition,
            owner:idcollectionProprio,
            read:rowUpdated.lecture,
            user_id:rowUpdated.id,
        };

        CollectionService.shareUnshareCollection(api, userAccountId,iddCollectionSelected,data).then((response) => {
            if(response.rows){
                setToast({ message: response.message , type: 'success' });                
            }else{
                setToast({ message: response.message , type: 'error' });
            }
            setLoading(false);  
        });
        setUserlist(prev => {
            // 1️ On met à jour l'utilisateur cliqué (en ignorant les lignes isFullRow)
            const updatedList = prev.map(user => {
                if (user.isFullRow) return user;
                if (user.id === id) {
                    return { ...user, lecture, edition, ajout, suppression };
                }
                return user;
            });
    
            // 2️ On retire les isFullRow pour ne garder que les utilisateurs réels
            const onlyUsers = updatedList.filter(u => !u.isFullRow);
    
            // 3️ Recalcule des groupes
            const groupe1 = onlyUsers
                .filter(u =>
                    u.isProprio || u.lecture || u.edition || u.ajout || u.suppression
                )
                .sort((a, b) => b.isProprio - a.isProprio); // proprio en premier
    
            const groupe2 = onlyUsers.filter(u => !groupe1.includes(u));
    
            // 4️ Reconstruction de la liste finale
            return [
                {  id:'groupe-1', isFullRow: true, fullText: 'Utilisateur ayant des droits sur cette collection' },
                ...groupe1.map(u => ({ ...u, groupId: 'groupe-1' })),
                {  id:'groupe-2', isFullRow: true, fullText: 'Autres utilisateurs ayant accès au module' },
                ...groupe2.map(u => ({ ...u, groupId: 'groupe-2' }))
            ];
        });

        
    };
    
    const columns = [
        { key: 'nom', label: "Nom de l'utilisateur", width:'200px'},
        { key: 'email', label: "Email", width:'250px'},
        {
            key: 'lecture',
            sortable: false,
            label:"Lecture",
            align: 'center', 
            render: (_, row) => (
                <input 
                    className={genStyles.inputtCol}
                    type="checkbox" 
                    checked={!!row.lecture} 
                    {...(row.isProprio  || mode === 'show' 
                        ? { readOnly: true } 
                        : { onChange: (e) => handleCheckboxChange(row.id,'lecture', e.target.checked) }
                    )}
                    disabled={row.isProprio || mode === 'show' }
                    style={{
                        cursor: row.isProprio  || mode === 'show' ? 'not-allowed' : 'pointer'
                    }}
                />
            )
        },
        {
            key: 'edition',
            sortable: false,
            label:"Édition",
            align: 'center', 
            render: (_, row) => (
                <input 
                    className={genStyles.inputtCol}
                    type="checkbox" 
                    checked={!!row.edition}  
                    {...(row.isProprio || mode === 'show' 
                        ? { readOnly: true } 
                        : { onChange: (e) => handleCheckboxChange(row.id,'edition', e.target.checked) }
                    )}
                    disabled={row.isProprio || mode === 'show' }
                    style={{
                        cursor: row.isProprio || mode === 'show'  ? 'not-allowed' : 'pointer'
                    }}
                />
            )
        },
        {
            key: 'ajout',
            sortable: false,        
            label:"Ajout",
            align: 'center', 
            render: (_, row) => (
                <input 
                    className={genStyles.inputtCol}
                    type="checkbox" 
                    checked={!!row.ajout}  
                    {...(row.isProprio || mode === 'show'  
                        ? { readOnly: true } 
                        : { onChange: (e) => handleCheckboxChange(row.id,'ajout', e.target.checked) }
                    )}
                    disabled={row.isProprio || mode === 'show' }
                    style={{
                        cursor: row.isProprio || mode === 'show'  ? 'not-allowed' : 'pointer'
                    }}
                />
            )
        },
        {
            key: 'suppression',
            sortable: false,
            label:'Suppression',
            align: 'center', 
            render: (_, row) => (
                <input 
                    className={genStyles.inputtCol}
                    type="checkbox" 
                    checked={!!row.suppression}  
                    {...(row.isProprio || mode === 'show'  
                        ? { readOnly: true } 
                        : { onChange: (e) => handleCheckboxChange(row.id,'suppression', e.target.checked) }
                    )}
                    disabled={row.isProprio || mode === 'show' }
                    style={{
                        cursor: row.isProprio || mode === 'show'  ? 'not-allowed' : 'pointer'
                    }}
                />
            )
        }
    ];
    

    const selectAllDataRow = () => {
        return;
    }

    return (
        <>
            <div className={`${genStyles.fontSize20} ${genStyles.buttonfooter} ${genStyles.bgcolorfirsttext}`}>
                Partager la collection : <b>{collectionName}</b>
            </div>
            <div className={genStyles.cnttblshared} >
               <ResultForm 
                    data={userlist} 
                    columns={columns} 
                    onSelectRow={selectAllDataRow} 
                    pageSize={100} 
                    tableHeight="300px" 
                    textpaginate="utilisateurs" 
                    texteSearch="Rechercher un utilisateur"
                    sortConfig={sortConfig}
                    setSortConfig={setSortConfig}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            </div>
            <div className={genStyles.buttonfooter}>
                <button
                className="btn red lighten-1 z-depth-0 mr5 ml5"
                style={{ width: '200px' }}
                onClick={onClose}
                >
                Fermer
                </button>                
            </div>
        </>
    );
}
